import { createContext, useContext, useState } from "react";

import { AuthState, defaultAuthState } from "../store/models/auth";

export const AuthContext = createContext<{
  authState: AuthState;
  setAuthState: React.Dispatch<React.SetStateAction<AuthState>>;
}>({
  authState: defaultAuthState,
  setAuthState: () => {},
});
